import { useQuery } from "@apollo/client"
import { client } from "../graphql/contentful/client"
import { gql } from "@apollo/client"
import { CaseModel } from "../components/contentful/models"
import { ContentfulEntryTypeName } from "../components/contentful/entries"

interface CaseCollectionQuery {
  caseCollection: {
    items: CaseModel<ContentfulEntryTypeName>[]
  }
}

export const QUERY_CASE_COLLECTION = gql`
  query getCaseContent {
    caseCollection {
      items {
        title
        description
        hero {
          image {
            url(transform: { format: WEBP, width: 1920, quality: 70 })
            description
          }
        }
      }
    }
  }
`

export const useCaseCollection = () => {
  const { data, error, loading, refetch } = useQuery<CaseCollectionQuery>(QUERY_CASE_COLLECTION, {
    client: client,
  })
  return { cases: data?.caseCollection, error, loading, refetch, query: QUERY_CASE_COLLECTION }
}
